<template>
  <div>
    <b-card>
      <div slot="header">
        <i
          class="fa fa-list-ul"
          aria-hidden="true"
        ></i>
        Token Management
      </div>
      <b-row class="my-1">
        <b-col sm="2">
          <b-button
            variant="outline-dark"
            @click="goToCreateToken()"
          >+ Create Token</b-button>
        </b-col>
        <b-col sm="10">
          <b-form-input
            type="text"
            placeholder="Search token or refId or groupId"
            sm="10"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <alert-fail :show="isError"> {{ errorMessage }} </alert-fail>
          <b-table
            stacked="sm"
            :busy="isBusy"
            :current-page="currentPage"
            :per-page="numberPerPage"
            class="table-app"
            tbody-class="tbody"
            hover
            thead-tr-class="thead-app"
            selectable
            selectedVariant="single"
            :fields="fields"
            :items="list"
          >
            <template
              slot="refId"
              slot-scope="row"
            >
              {{ row.item.refId }}
            </template>
            <template
              slot="token_details"
              slot-scope="row"
            >
              <b-button
                size="sm"
                @click="row.toggleDetails"
              >{{ row.detailsShowing ? 'Hide' : 'Show'}}</b-button>
            </template>
            <template v-slot:row-details="row">
              <b-card>
                <b-card-body title="Token Detail (iOS)">
                  <b-card-text v-html="row.item.iosDetail">
                  </b-card-text>
                </b-card-body>
                <b-card-body title="Token Detail (android)">
                  <b-card-text v-html="row.item.androidDetail">
                  </b-card-text>
                </b-card-body>
                <b-card-body title="Tags">
                  <b-card-text v-html="row.item.tags">
                  </b-card-text>
                </b-card-body>
                <b-button
                  size="sm"
                  @click="row.toggleDetails"
                >Hide Details</b-button>
                <b-button
                  class="ml-2"
                  size="sm"
                  variant="danger"
                  @click="deleteUserToken(row.item)"
                >Delete</b-button>
              </b-card>
            </template>
            <div
              slot="table-busy"
              class="text-center text-dark my-2"
            >
              <b-spinner
                variant="dark"
                class="align-middle"
              ></b-spinner>
              <strong>Loading...</strong>
            </div>
          </b-table>
          <hr />
          <b-row>
            <b-col>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="numberPerPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import AlertFail from '@/components/alert/AlertFail';
export default {
  data () {
    return {
      isBusy: false,
      numberPerPage: 10,
      fields: [
        { key: 'refId' },
        { key: 'createdBy' },
        { key: 'createdAt' },
        { key: 'updatedBy' },
        { key: 'updatedAt' },
        { key: 'token_details' }
      ],
      list: [],
      isError: false,
      errorMessage: '',
      currentPage: 1,
      totalRows: 1
    };
  },
  methods: {
    async getTokens () {
      try {
        const tokenResponse = await this.axios.get(`${process.env.VUE_APP_URL_MESSAGING_API}/device-token`);
        const tokens = tokenResponse.data.data.deviceTokens;

        for (let token of tokens) {
          let id = token.id;
          let refId = token.refId;
          let createdBy = token.createdBy;
          let createdAt = new Date(token.createdAt).toLocaleString();
          let updatedBy = token.updatedBy;
          let updatedAt = new Date(token.updatedAt).toLocaleString();

          let iOSDeviceToken = '';
          let iOSDeviceDetail = '';
          let androidDeviceToken = '';
          let androidDeviceDetail = '';
          let tags = '';

          for (let device of token.devices) {
            if ('ios' === device.platform) {
              iOSDeviceDetail += this.getJsonPropData(device);
            }
            if ('android' === device.platform) {
              androidDeviceDetail += this.getJsonPropData(device);
            }
          }

          for (let tag of token.tags) {
            tags += tag.text + '<br/>';
          }

          this.list.push({
            id: id,
            refId: refId,
            ios: iOSDeviceToken,
            iosDetail: iOSDeviceDetail,
            android: androidDeviceToken,
            androidDetail: androidDeviceDetail,
            tags: tags,
            createdBy: createdBy,
            createdAt: createdAt,
            updatedBy: updatedBy,
            updatedAt: updatedAt
          });
        }
      } catch (e) {
        this.errorMessage = e.response.data.message;
        if ('UAT-003' === e.response.data.code) {
          this.$router.push({ name: 'login' });
        }
      }

      this.totalRows = this.list.length;
      this.isBusy = false;
      return this.list;
    },
    goToCreateToken () {
      this.$router.push({ name: 'messaging-create-user-token' });
    },
    getJsonPropData (payload) {
      let payloadText = '';
      for (let p in payload) {
        payloadText += p + ': ' + payload[p] + '<br>';
      }
      return payloadText;
    },
    deleteUserToken (item) {
      this.axios.delete(process.env.VUE_APP_URL_MESSAGING_API + '/device-token/' + item.id)
        .then(response => {
          this.list = [];
          this.getTokens();
          this.$bvModal.msgBoxOk('Delete was submitted successfully', {
            title: 'Confirmation',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true
          });
        })
        .catch(error => {
          this.errorMessage = error.response.data.message;
        });
    }
  },
  components: {
    AlertFail
  },
  created () {
    this.getTokens();
    document.title = 'Admin Console: Messaging Tokens';
  }
};
</script>
